import { AfterViewInit, Directive, Input, OnDestroy } from '@angular/core';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';

@Directive({
  selector: '[autocompletePosition]'
})
export class AutocompletePositionDirective implements OnDestroy, AfterViewInit {
  private matAutocompleteTrigger: MatAutocompleteTrigger;

  @Input() set autocompletePosition(value: MatAutocompleteTrigger) {
    this.matAutocompleteTrigger = value;
    window.addEventListener('scroll', this.scrollEvent, true);
  }

  private scrollEvent = (event: Event): void => {
    //console.log()
    const isScrollingInsideDropdown = (event.target as HTMLElement).closest('.mat-autocomplete-panel');

    if (isScrollingInsideDropdown) {
      return;
    }

    if (this.matAutocompleteTrigger && this.matAutocompleteTrigger.panelOpen) {
      this.matAutocompleteTrigger.closePanel();
    }
  };

  ngAfterViewInit() {
    if (this.matAutocompleteTrigger) {
      window.addEventListener('scroll', this.scrollEvent, true);
    }
  }

  ngOnDestroy() {
    window.removeEventListener('scroll', this.scrollEvent, true);
  }
}
